import { render, staticRenderFns } from "./ViewMarketplaceProfile.vue?vue&type=template&id=26ec1e07&lang=true"
import script from "./ViewMarketplaceProfile.vue?vue&type=script&lang=js"
export * from "./ViewMarketplaceProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports